const fixExcerpt = (content) => {
  if (!content?.length) {
    return content;
  }

  const prepareContent = content.map((item) => {
    const { children } = item;

    return {
      ...item,
      children: children.filter((child) => !child.children || child.children?.length > 0),
    };
  });

  return prepareContent;
};

export default fixExcerpt;
